import React, { useEffect, useState } from 'react';
import { List, fromJS } from 'immutable';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import qs from 'query-string';
import { push } from 'connected-react-router';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Block,
  View,
} from '@uncinc/react-drupal-core';

import {
  getVacanciesByDistance,
} from '../../../store/actions/UI';

import LocationsData from '../../View/Locations/LocationsData';

import ListMapToggler from '../../../components/ListMapToggler';
import AutoComplete from '../../../components/AutoComplete';
import { VACANCY_OVERVIEW_URL } from '../../../config/constants';

import './style.scss';

const DISTANCE_FILTER_OPTIONS_LIST = [{ label: 'Alles', value: null }, { label: '< 2km', value: 2000 }, { label: '< 5km', value: 5000 }, { label: '< 10km', value: 10000 }, { label: '< 20km', value: 20000 }];

const ParagraphLatestVacancies = ({ id, entity }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const ctaBlockId = entity.getIn(['field_custom_block', 0, 'target_id'], null);

  const queryParams = qs.parse(window.location.search);

  const initialState = fromJS({
    lat: queryParams.lat || 0,
    lon: queryParams.lon || 0,
    currentPage: queryParams.currentPage,
    filter: queryParams.filter,
    distance: null,
  });

  const [currentItem, setCurrentItem] = useState(Object.fromEntries(initialState));
  const [currentPage, setCurrentPage] = useState(0);
  const [distanceFilter, setDistanceFilter] = useState(null);
  const [markers, setMarkers] = useState(List());
  const coordinatesProvided = queryParams.lat;

  const vacancyIdsByDistance = useSelector((state) => state.getIn(['uiInternal', 'vacancy_ids_by_distance', 'ids'], List()));
  const totalPages = useSelector((state) => state.getIn(['uiInternal', 'vacancy_ids_by_distance', 'total_pages'], 10));

  const setQuery = (query) => {
    dispatch(push(`${VACANCY_OVERVIEW_URL}?${query}`));
  };

  const setQueryStringValues = (obj) => {
    const newState = Object.fromEntries(initialState.merge({
      lat: obj.lat,
      lon: obj.lon,
      currentPage: currentPage || obj.currentPage,
      distance: distanceFilter,
    }));

    const currentValues = qs.parse(queryParams);
    const newQuery = qs.stringify(Object.fromEntries(
      Object.entries({ ...currentValues, ...newState }).filter(([_, v]) => v !== ''),
    ));

    setQuery(newQuery);
  };

  const getVacancies = (obj) => {
    setQueryStringValues(obj);
    dispatch(getVacanciesByDistance(
      obj.lat,
      obj.lon,
      distanceFilter,
      currentPage,
    ));
  };

  useEffect(() => {
    getVacancies(currentItem);
  }, [currentPage, distanceFilter, currentItem, currentItem.lat, currentItem.lon]);

  useEffect(() => {
    if (queryParams.currentPage) setCurrentPage(parseInt(queryParams.currentPage));
  }, [queryParams.currentPage]);

  const getClosestsResults = (item) => {
    if (item.lat && item.lon) {
      setCurrentItem(item);
      setCurrentPage(0);
      getVacancies(item);
    }
  };

  return (
    <div id={id} className="ParagraphLatestVacancies Morea">
      {ctaBlockId !== null &&
        <Container>
          <div className="row">
            <div className="col-12 col-lg-10">
              <Block
                id={ctaBlockId}
              />
            </div>
          </div>
        </Container>}

      {/* Start Filters */}
      <Container>
        <div className="row ParagraphLatestVacancies__filters">
          <div className="col-12 col-lg-4 dropdown-holder">
            <AutoComplete
              defaultValue={coordinatesProvided ? queryParams.input : null}
              locationsData={markers}
              callback={getClosestsResults}
              onEnterTakeFirstResult
            />
          </div>

          {coordinatesProvided !== '0' && (
            <div className="col-12 col-lg-4 distance-filter">
              <b>{t('filters.distance.placeholder')}</b>
              <Select
                placeholder={t('filters.distance_type')}
                options={DISTANCE_FILTER_OPTIONS_LIST}
                onChange={(e) => {
                  setDistanceFilter(e.value);
                  setCurrentPage(0);
                }}
                className="Select"
                classNamePrefix="Select"
              />
            </div>
          )}
          <ListMapToggler />
        </div>
      </Container>
      {/* End Filters */}

      {/* Load in our locations data for the autocomplete */}
      <LocationsData
        markersCallback={(data) => {
          setMarkers(markers.merge(data));
        }}
      />

      {/* Start Content */}
      <div className="row">
        <div className="ParagraphLatestVacancies__inner col-12">
          <View
            className="ParagraphLatestVacancies__view"
            page={0}
            args={[vacancyIdsByDistance.toJS().join('+')]}
            id="latest_vacancies"
            setCurrentPage={setCurrentPage}
            display="block_2"
            totalPages={totalPages}
          />
        </div>
      </div>
      {/* End Content */}

    </div>
  );
};

export default ParagraphLatestVacancies;
